<template>
  <component :is="icon" />
</template>

<script>
import { ppe as PPEIcons } from '@/lib/generic-lists';
import BootsIcon from '@/components/siteParts/icons/boots.vue';
import EarmuffsIcon from '@/components/siteParts/icons/earmuffs.vue';
import GlassesIcon from '@/components/siteParts/icons/glasses.vue';
import GlovesIcon from '@/components/siteParts/icons/gloves.vue';
import HardhatIcon from '@/components/siteParts/icons/hardhat.vue';
import LongsIcon from '@/components/siteParts/icons/longs.vue';
import MaskIcon from '@/components/siteParts/icons/mask.vue';
import VestIcon from '@/components/siteParts/icons/vest.vue';

export default {
  name: 'PPE',
  components: {
    BootsIcon, // eslint-disable-line vue/no-unused-components
    EarmuffsIcon, // eslint-disable-line vue/no-unused-components
    GlassesIcon, // eslint-disable-line vue/no-unused-components
    GlovesIcon, // eslint-disable-line vue/no-unused-components
    HardhatIcon, // eslint-disable-line vue/no-unused-components
    LongsIcon, // eslint-disable-line vue/no-unused-components
    MaskIcon, // eslint-disable-line vue/no-unused-components
    VestIcon, // eslint-disable-line vue/no-unused-components
  },
  props: {
    // e.g. 'Steel capped boots'
    ppe: String,
  },
  computed: {
    icon() {
      const ppeItem = PPEIcons.find((item) => item.name.toLowerCase() === this.ppe.toLowerCase());

      if (ppeItem) {
        return `${ppeItem.icon}Icon`;
      }

      return 'BootsIcon'; // default
    },
  },
};
</script>
